import React from "react";
import { UserEditLoaderTemplate } from "themes/administration/user/components";

function UserEditLoader(props) {
    return <UserEditLoaderTemplate {...props} />;
}

export default UserEditLoader;
